import jsPDF from 'jspdf'
import 'jspdf-autotable'
import XLSX from 'xlsx'

export const exportToCSV = ({
  arrData = [], institutionName, reportDate = '', reportBranch = '', reportLevel = '', fileName,
}) => {
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    [institutionName],
    [fileName],
    [`${(reportDate !== '') ? `As at ${reportDate}` : 'Date: All'}`],
    [`${(reportBranch !== '') ? `${reportBranch.label}` : 'Branch: All'}`],
    [`Level ${reportLevel}`],
    [],

    Object.keys(arrData[0]).join(','),
    ...arrData.map(item => Object.values(item).join(',')),
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', `${fileName}.csv`)
  link.click()
}

export const exportToExcel = ({
  arrData = [], institutionName, reportDate = '', reportBranch = '', reportLevel = '', fileName,
}) => {
  const headerLists = [
    Object.keys(arrData[0]),
  ]

  const Heading = [
    [institutionName],
    [fileName],
    [`${(reportDate !== '') ? `As at ${reportDate}` : 'Date: All'}`],
    [`${(reportBranch !== '') ? `${reportBranch.label}` : 'Branch: All'}`],
    [`Level ${reportLevel}`],
    [],
    headerLists[0], // Headers lists
  ]
  const Data = arrData // All data lists
  const ws = XLSX.utils.aoa_to_sheet(Heading)
  XLSX.utils.sheet_add_json(ws, Data, {
    skipHeader: true,
    origin: -1,
  })

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, fileName)
  XLSX.writeFile(wb, `${fileName}.xlsx`)
}

export const exportToPDF = ({
  arrData = [], columns, institutionName, fileName = '', reportTitle = '', reportDate = '', reportBranch = '', reportLevel = '', orientation = 'portrait',
}) => {
  const doc = jsPDF(orientation, 'pt', 'a4')
  doc.setFontSize(20)
  doc.text(100, 60, `${institutionName}`)
  doc.setFontSize(15)
  doc.text(100, 80, reportTitle)
  doc.setFontSize(12)
  doc.text(100, 95, `${(reportDate !== '') ? `As at ${reportDate}` : 'Date: All'}`)
  doc.text(100, 110, `${(reportBranch !== '') ? `${reportBranch.label}` : 'Branch: All'}`)
  doc.text(100, 125, `${(reportLevel !== '') ? `Level ${reportLevel}` : ''}`)

  doc.autoTable({
    theme: 'striped', // grid, plain
    columns,
    body: arrData,
    startY: 150,
    // split overflowing columns into pages
    horizontalPageBreak: true,
    // repeat this column in split pages
    horizontalPageBreakRepeat: 'id',
    tableWidth: 'auto',
    margin: {
      horizontal: 20,
      vertical: 20,
    },
    bodyStyles: {
      valign: 'top',
    },
    styles: {
      overflow: 'linebreak',
      cellWidth: 'wrap',
      maxCellHeight: 4,
      fontSize: 10,
      cellPadding: 10,
    },
    columnStyles: {
      text: {
        cellWidth: 'auto',
      },
    },
  })
  // Footer page number
  const pages = doc.internal.getNumberOfPages()
  const pageWidth = doc.internal.pageSize.width
  const pageHeight = doc.internal.pageSize.height
  doc.setFontSize(10)

  for (let j = 1; j < pages + 1; j += 1) {
    const horizontalPos = pageWidth / 2 // Can be fixed number
    const verticalPos = pageHeight - 10 // Can be fixed number
    doc.setPage(j)
    doc.text(`page ${j} of ${pages}`, horizontalPos, verticalPos, { align: 'center' }) // Optional text styling});
  }
  doc.save(fileName)
}

// LMS:

export const lmsExportToCSV = ({
  arrData = [], institutionName, startDate = '', fileName,
}) => {
  let csvContent = 'data:text/csv;charset=utf-8,'
  csvContent += [
    [institutionName],
    [fileName],
    [`${(startDate !== '') ? `As at ${startDate}` : ''}`],
    [],

    Object.keys(arrData[0]).join(','),
    ...arrData.map(item => Object.values(item).join(',')),
  ]
    .join('\n')
    .replace(/(^\[)|(\]$)/gm, '')

  const data = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', `${fileName}.csv`)
  link.click()
}

export const lmsExportToExcel = ({
  arrData = [], institutionName, startDate = '', fileName,
}) => {
  const headerLists = [
    Object.keys(arrData[0]),
  ]

  const Heading = [
    [institutionName],
    [fileName],
    [`${(startDate !== '') ? `As at ${startDate}` : ''}`],
    [],
    headerLists[0], // Headers lists
  ]
  const Data = arrData // All data lists
  const ws = XLSX.utils.aoa_to_sheet(Heading)
  XLSX.utils.sheet_add_json(ws, Data, {
    skipHeader: true,
    origin: -1,
  })

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, fileName)
  XLSX.writeFile(wb, `${fileName}.xlsx`)
}

export const lmsExportToPDF = ({
  arrData = [], columns, institutionName, fileName = '', reportTitle = '', startDate = '', orientation = 'portrait',
}) => {
  const doc = jsPDF(orientation, 'pt', 'a4')
  doc.setFontSize(20)
  doc.text(100, 60, `${institutionName}`)
  doc.setFontSize(15)
  doc.text(100, 80, reportTitle)
  doc.setFontSize(12)
  doc.text(100, 95, `${(startDate !== '') ? `As at ${startDate}` : ''}`)

  doc.autoTable({
    theme: 'striped', // grid, plain
    columns,
    body: arrData,
    startY: 150,
    // split overflowing columns into pages
    horizontalPageBreak: true,
    // repeat this column in split pages
    horizontalPageBreakRepeat: 'id',
    tableWidth: 'auto',
    margin: {
      horizontal: 20,
      vertical: 20,
    },
    bodyStyles: {
      valign: 'top',
    },
    styles: {
      overflow: 'linebreak',
      cellWidth: 'wrap',
      maxCellHeight: 4,
      fontSize: 10,
      cellPadding: 10,
    },
    columnStyles: {
      text: {
        cellWidth: 'auto',
      },
    },
  })
  // Footer page number
  const pages = doc.internal.getNumberOfPages()
  const pageWidth = doc.internal.pageSize.width
  const pageHeight = doc.internal.pageSize.height
  doc.setFontSize(10)

  for (let j = 1; j < pages + 1; j += 1) {
    const horizontalPos = pageWidth / 2 // Can be fixed number
    const verticalPos = pageHeight - 10 // Can be fixed number
    doc.setPage(j)
    doc.text(`page ${j} of ${pages}`, horizontalPos, verticalPos, { align: 'center' }) // Optional text styling});
  }
  doc.save(fileName)
}
